import { IEventDetailsDTO } from '../../../../../api/events.dao';
import { IManageProductsSelection, selectionLineTotal } from './manage-products.viewmodel';

interface IManageProductsTrackingInput {
    event: IEventDetailsDTO;
    orderId: string | null;
    priceBookName: string;
    previous: IManageProductsSelection[];
    current: IManageProductsSelection[];
}

const isModified = (before: IManageProductsSelection, after: IManageProductsSelection): boolean =>
    before.unitPrice !== after.unitPrice ||
    before.quantity !== after.quantity ||
    before.notes !== after.notes;

export class ManageProductsTrackingMapper {
    public static toTrackingEvent(input: IManageProductsTrackingInput): Record<string, string | number> {
        const { event, orderId, priceBookName, previous, current } = input;
        const previousById = new Map(previous.map(selection => [selection.rowId, selection]));
        const currentById = new Map(current.map(selection => [selection.rowId, selection]));

        const added = current.filter(selection => !previousById.has(selection.rowId)).length;
        const removed = previous.filter(selection => !currentById.has(selection.rowId)).length;
        const modified = current.filter(selection => {
            const before = previousById.get(selection.rowId);
            return before != null && isModified(before, selection);
        }).length;

        const orderTotal = current.reduce((sum, selection) => sum + selectionLineTotal(selection), 0);

        return {
            'Account Name': event?.accountName ?? '',
            'Account ID': event?.accountId != null ? String(event.accountId) : '',
            'Event ID': event?.eventId != null ? String(event.eventId) : '',
            'SF Order ID': orderId ?? '',
            'Products Added': added,
            'Products Removed': removed,
            'Products Modified': modified,
            'Price Book Name': priceBookName ?? '',
            'Order Total': orderTotal,
        };
    }
}
